import type { StaffMemberCategory } from '../app/types/account.type.ts';
import baseApi, { CacheTag } from './meeting-md-api-slice';

const staffMemberCategoryApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchStaffMemberCategories: builder.query<StaffMemberCategory[], void>({
      query: () => ({ url: '/StaffMemberCategory' }),
      providesTags: [CacheTag.Account, CacheTag.CurrentUser],
    }),
  }),
});

export const { useFetchStaffMemberCategoriesQuery } = staffMemberCategoryApi;
